/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';

/**
 * Provides a utility hook for determining whether draw has been completed or not.
 *
 * ```typescript
 *
 *  const [finishedDrawing, setFinishedDrawing] = useDrawingComplete(isBoundary, handleApplyBoundary);
 *
 * ```
 */
export const useDrawingComplete = (isBoundary = false, handleApplyBoundary?: Function, initialState = false): [
    finishedDrawing: boolean,
    onCompleteDrawing: Function
] => {
  const [finishedDrawing, setFinishedDrawing] = useState(initialState);

  const onCompleteDrawing = () => {
    if (isBoundary) {
      handleApplyBoundary?.();
    } else {
      setFinishedDrawing(true);
    }
  };

  return [finishedDrawing, onCompleteDrawing];
};

export default useDrawingComplete;
